import { SVG } from '@svgdotjs/svg.js'
import { Carousel, Scrollbar, Viewport } from '../core'

const MAP_TOP = 47.515,
MAP_BOTTOM = 46.205,
MAP_LEFT = 73.71,
MAP_RIGHT = 70.705,
MAP_WIDTH = 1366,
MAP_HEIGHT = 854,
ZOOM_LEVELS = [1.3, 1.8, 2.5],
MAP_STYLE = [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#202c2d"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#3499a2"},{"visibility":"on"}]}],
MAP_OPTIONS = {
  selectors: {
    form: '.locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'select[name="radius"]',
    limit: 'select[name="limit"]',
  },
  basicOptions: {
    zoom: 11,
    singleMapZoom: 11,
    maxZoom: 18,
    minZoom: 4,
    lat: 47.651,
    lng: -70.1503,
    mapStyle: MAP_STYLE,
    autoFadeIn: true,
    autoFitBounds: false,
    enableGeolocation: false,
    enablePositionMarker: false,
    putSearchParametersInURL: false,
  },
  clusterOptions: {
    useClusters: false,
  },
  bubbleOptions: {
    useBubbles: false,
  },
  getMarkerIcon: function() {
    let markerIcon = {
      url: '/img/elements/map-marker.svg',
      width: 32,
      height: 44,
      anchorX: 32 / 2,
      anchorY: 44,
      scaledWidth: 32,
      scaledHeight: 44,
    }
    return markerIcon
  },
}

let easeInOutQuart = function(pos) {
  if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 4)
  return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2)
}

let MapMarker = function(type, icon, location, map) {
  let self = this
  self.type = type
  self.data = location
  self.icon = icon
  self.title = $('.location-title[data-id="' + location.id + '"]')
  self.original_width = self.icon.width()
  self.original_height = self.icon.height()
  self.original_fill = self.icon.attr('fill')
  self.viewport_scale = 1
  self.timeouts = {
    panel: undefined,
    content: undefined,
  }

  self.clicked = function(e) {
    let panelTimeout = 0, contentTimeout = 0
    clearTimeout(self.timeouts.panel)
    clearTimeout(self.timeouts.content)
    if (!$('.territoire-main-panel__' + self.type).hasClass('territoire-main-panel--opened')) {
      if ($('.territoire-module').hasClass('territoire-module--opened')) {
        contentTimeout += 300
      }
      self.timeouts.panel = setTimeout(function() {
        $('button[name="open-panel-' + self.type + '"]').trigger('click')
      }, panelTimeout)
      contentTimeout += 300
    }
    let targetLink = $('.' + self.type + '__item[data-id="' + self.get_id() + '"] > a')
    if (targetLink.parents('.categories__item').length) {
      self.timeouts.content = setTimeout(function() {
        if (targetLink.parents('.initiatives__list').attr('aria-hidden') == 'true') {
          targetLink.parents('.categories__item').find('.categories__link').trigger('click')
        }
      }, contentTimeout - 150)
    }
    self.timeouts.content = setTimeout(function() {
      targetLink.trigger('click')
    }, contentTimeout)
  }

  self.set_title_position = function() {
    self.title.css({
      top: self.get_pos_top(),
      left: self.get_pos_left(),
    })
  }

  self.get_id = function() {
    return location.id
  }

  self.get_lat_y = function() {
    return Math.round(MAP_HEIGHT - ((location.lat - MAP_BOTTOM) / (MAP_TOP - MAP_BOTTOM) * MAP_HEIGHT))
  }

  self.get_lng_x = function() {
    return Math.round(MAP_WIDTH - ((-location.lng - MAP_RIGHT) / (MAP_LEFT - MAP_RIGHT) * MAP_WIDTH))
  }

  self.get_pos_top = function() {
    return ((self.get_lat_y() / MAP_HEIGHT) * 100) + '%'
  }

  self.get_pos_left = function() {
    return ((self.get_lng_x() / MAP_WIDTH) * 100) + '%'
  }

  self.hover_in = function() {
    self.title.attr('aria-hidden', 'false')
    let icon_scale = self.type == 'municipalites' ? 1.25 : 1.5,
    icon_fill = self.type == 'municipalites' ? '#EEB515' : self.original_fill
    self.icon.timeline().finish()
    self.icon.animate({
      duration: 350,
      when: 'now',
    }).attr({
      'fill': icon_fill,
    }).size(self.original_width / self.viewport_scale * icon_scale, self.original_height / self.viewport_scale * icon_scale).dmove(-self.original_width / self.viewport_scale * (icon_scale / 2 - .5), -self.original_height / self.viewport_scale * (icon_scale / 2 - .5))
  }

  self.hover_out = function() {
    $('.location-title[data-id="' + self.get_id() + '"]').attr('aria-hidden', 'true')
    let icon_scale = self.type == 'municipalites' ? 1.25 : 1.5;
    self.icon.timeline().finish()
    self.icon.animate({
      duration: 350,
      when: 'now',
    }).attr('fill', self.original_fill).size(self.original_width / self.viewport_scale, self.original_height / self.viewport_scale).dmove(self.original_width / self.viewport_scale * (icon_scale / 2 - .5), self.original_height / self.viewport_scale * (icon_scale / 2 - .5))
  }

  self.set_icon_size = function() {
    self.viewport_scale = map.viewport.width() / MAP_WIDTH
    if ($.mlmi.mobile.isMobile) {
      self.viewport_scale /= .4
    }
    self.icon.size(self.original_width / self.viewport_scale, self.original_height / self.viewport_scale)
    self.icon.cx(self.get_lng_x())
    self.icon.cy(self.get_lat_y() - (self.type == 'municipalites' ? self.original_height / self.viewport_scale / 2 : 0))
  }

  return function() {
    $(window).on('load resize orientationchange', function() {
      requestAnimationFrame(self.set_icon_size)
    })
    self.set_icon_size()
    self.set_title_position()
    self.icon.on('click', self.clicked)
    self.icon.on('mouseenter', self.hover_in)
    self.icon.on('mouseleave', self.hover_out)
    self.icon.css('cursor', 'pointer')
    self.icon.show()
    return self
  }()
}

$.fn.Territoire_Map = function(territoire) {
  let self = this

  if (self.data('territoire-map')) {
    return self.data('territoire-map')
  }

  self.map = SVG(self.find('.territoire-map__illustration > svg').get(0))
  self.viewport = self.find('.territoire-map__viewport')
  self.illustration = self.find('.territoire-map__illustration')
  self.zoom_level = -1
  self.zoom_scale = 1
  self.controls = {
    zoomIn: self.find('button[name="territoire-map-zoom-in"]'),
    zoomOut: self.find('button[name="territoire-map-zoom-out"]'),
  }
  self.markers = {
    templates: {
      initiative: self.map.findOne('#initiative'),
      municipalite: self.map.findOne('#municipalite'),
    },
    indexed: {}
  }
  self.scalables = [
    self.map.findOne('#scale-la-tuque'),
    self.map.findOne('#scale-shawinigan'),
    self.map.findOne('#scale-trois-rivieres'),
    self.map.findOne('#scale-levis'),
    self.map.findOne('#scale-quebec'),
  ]

  self.getMarker = function(id) {
    return self.markers.indexed['m_' + id]
  }

  self.addMarker = function(marker) {
    self.markers.indexed['m_' + marker.data.id] = marker
    self.map.add(marker.icon)
  }

  self.zoom_to = function(zoom_level, clicked_id, animation_duration) {
    if (animation_duration == undefined) {
      animation_duration = 550
    }
    self.zoom_level = zoom_level
    let zoom_scale = ZOOM_LEVELS[zoom_level]
    self.illustration.removeClass('--zoom-0 --zoom-1 --zoom-2')
    self.illustration.addClass('--zoom-' + zoom_level)
    self.scalables.forEach(function(scalable) {
      scalable.animate({
        duration: animation_duration,
        when: 'now',
      }).ease(easeInOutQuart).scale(self.zoom_scale / zoom_scale)
    })
    for (var index in self.markers.indexed) {
      let marker = self.markers.indexed[index]
      let runner = marker.icon.animate({
        duration: animation_duration,
        when: 'now',
      }).ease(easeInOutQuart).scale(self.zoom_scale / zoom_scale, self.zoom_scale / zoom_scale, marker.get_lng_x(), marker.get_lat_y())
    }
    if (!$.mlmi.mobile.isMobile && clicked_id != undefined) {
      requestAnimationFrame(function() {
        let targetX = $(window).width() - ($(window).width() - $('.territoire-module__panels').outerWidth(false) - $('.territoire-module__content-panel').outerWidth(false)) / 2
        let currentX = self.viewport.width() / 2 + self.viewport.offset().left
        let translateX = targetX - currentX
        self.getMarker(clicked_id).title.addClass('location-title--current')
        self.illustration.css({
          transform: 'translateX(' + translateX + 'px)',
          left: 'calc(-80% - ((' + self.getMarker(clicked_id).get_pos_left() + ' - 50%) * 2))',
          top: 'calc(-86% - ((' + self.getMarker(clicked_id).get_pos_top() + ' - 50%) * 2))',
        })
      })
    } else {
      self.illustration.css({
        transform: '',
        left: '',
        top: '',
      })
    }
    self.zoom_scale = zoom_scale
  }

  self.zoom_in = function() {
    if (self.zoom_level == 1) {
      self.zoom_to(2)
    } else if (self.zoom_level < 1) {
      self.zoom_to(1)
    }
  }

  self.zoom_out = function() {
    if (territoire.content_panel.hasModifier('opened')) {
      territoire.remove_content()
      territoire.content_panel.removeModifier('opened')
    }
    if (self.zoom_level == 2) {
      self.zoom_to(1)
    } else {
      self.zoom_to(0)
    }
  }

  return function() {
    self.markers.templates.initiative.hide()
    self.markers.templates.municipalite.hide()
    if ('locations' in window) {
      for (let index in territoire.locations) {
        let location = territoire.locations[index]
        if (location.filters.indexOf('municipalites') !== -1) {
          let markerTemplate = self.markers.templates.municipalite.clone(),
          marker = new MapMarker('municipalites', markerTemplate, location, self)
          self.addMarker(marker)
        }
      }
      for (let index in territoire.locations) {
        let location = territoire.locations[index]
        if (location.filters.indexOf('initiatives') !== -1) {
          let markerTemplate = self.markers.templates.initiative.clone(),
          marker = new MapMarker('initiatives', markerTemplate, location, self)
          self.addMarker(marker)
        }
      }
    }
    self.controls.zoomIn.on('click', self.zoom_in)
    self.controls.zoomOut.on('click', self.zoom_out)
    self.zoom_to(0, undefined, 1)
    self.data('territoire-map', self)
    return self
  }()
}

$.fn.Territoire_CategoryList = function() {
  let self = this
  self.header = self.find('.categories__link')
  self.content = self.find('.initiatives__list')

  self.calculate_height = function() {
    let maxHeight = 0
    self.content.find('.initiatives__link').each(function() {
      maxHeight += $(this).outerHeight(false)
    })
    self.content.css('max-height', maxHeight + 'px')
  }

  self.header_clicked = function(e) {
    if (self.content.attr('aria-hidden') == 'true') {
      self.header.attr('aria-expanded', 'true')
      self.content.attr('aria-hidden', 'false')
    } else {
      self.header.attr('aria-expanded', 'false')
      self.content.attr('aria-hidden', 'true')
    }
    return false
  }

  return function() {
    self.header.on('click', self.header_clicked)
    $(window).on('resize orientationchange load', self.calculate_height)
    self.calculate_height()
    return self
  }()
}

$.fn.Territoire_CategoriesList = function() {
  let self = this

  return function() {
    self.find('.categories__item').each(function() {
      $(this).Territoire_CategoryList()
    })
  }()
}

$.fn.Territoire_Location = function(territoire) {
  let self = this.BlockElement()
  self.scrollbar = undefined
  self.carousel = undefined
  self.map = self.find('.location__map')

  self.id = function() {
    return parseInt(self.attr('data-id'), 10)
  }

  self.appear = function() {
    requestAnimationFrame(function() {
      self.addModifier('visible')
    })
  }

  self.disappear = function(callback) {
    self.addModifier('hidden')
    setTimeout(function() {
      territoire.locator = territoire.locator.detach()
      callback()
    }, 300)
  }

  self.initialize_carousel = function() {
    self.carousel = new Carousel(self.find('.swiper-container').get(0), {
      slidesPerView: 1,
      resizeObserver: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }).init()
  }

  self.initialize_scrollbar = function() {
    requestAnimationFrame(function() {
      self.find('.location__body').each(function() {
        let scrollbar = new Scrollbar($(this), {
          mobile: true,
          preventWheelPropagation: true,
        })
      })
    })
  }

  self.initialize_locator = function() {
    if (territoire.locator == undefined) {
      territoire.locator = self.map.MLMI_Locator(MAP_OPTIONS)
      territoire.locator.isSingleLocation = true
      territoire.locator.on('marker_clicked', function(e, locator, marker) {
        window.open(marker.location.google_maps_link, '_blank');
      })
    } else {
      self.map.replaceWith(territoire.locator)
    }
    let markers = []
    territoire.locations.forEach(function(location) {
      if (location.id == self.id()) {
        markers.push(location)
      }
    })
    territoire.locator.setMarkers(markers)
  }

  return function() {
    self.initialize_carousel()
    self.initialize_scrollbar()
    self.initialize_locator()
    return self
  }()
}

$.fn.Territoire = function() {
  let self = $(this).BlockElement()
  self.locations = window.locations
  self.map = undefined
  self.locator = undefined
  self.panel_viewport = undefined
  self.content_panel = self.find('.territoire-module__content-panel').BlockElement('territoire-content-panel')
  new Viewport({
    selector: self.content_panel.get(0),
    innerMinHeight: false,
    force: true,
    desktop: false,
    filter: function(targetHeight) {
      targetHeight -= $('.header').outerHeight(false)
      return targetHeight
    },
  })
  self.controls = {
    btnMunicipalites: self.find('button[name="open-panel-municipalites"]'),
    btnInitiatives: self.find('button[name="open-panel-initiatives"]'),
    btnCloseMunicipalites: self.find('button[name="close-panel-municipalites"]'),
    btnCloseInitiatives: self.find('button[name="close-panel-initiatives"]'),
    btnCloseContent: self.find('button.territoire-content-panel__close-btn'),
  }
  self.links = self.find('.municipalites__link, .initiatives__link')
  self.current_location = undefined

  if (self.data('block-territoire')) {
    return self.data('block-territoire')
  }

  self.close_content = function() {
    self.remove_content()
    self.content_panel.removeModifier('opened')
  }

  self.close_panels = function(prevent_close) {
    if (prevent_close != true) {
      if (self.panel_viewport != undefined) {
        self.panel_viewport.kill()
        self.panel_viewport = undefined
      }
    }
    let timeout = 60
    if (self.content_panel.hasModifier('opened')) {
      self.remove_content()
      self.content_panel.removeModifier('opened')
      timeout = 360
    }
    if (self.map.zoom_level == 2) {
      self.map.zoom_out()
    }
    setTimeout(function() {
      self.removeModifier('opened')
      self.controls.btnMunicipalites.attr('aria-expanded', 'false')
      self.controls.btnInitiatives.attr('aria-expanded', 'false')
      $('.territoire-main-panel__municipalites, .territoire-main-panel__initiatives').removeClass('territoire-main-panel--opened')
    }, timeout)
    return timeout
  }

  self.open_panel = function() {
    let targetPanel = $(this)
    if ($.mlmi.mobile.isMobile) {
      self.panel_viewport = new Viewport({
        selector: '.territoire-module__main-panel',
        inner: false,
        innerMinHeight: false,
        force: true,
        filter: function(targetHeight) {
          targetHeight -= $('.header').outerHeight(false)
          return targetHeight
        },
      })
    }
    setTimeout(function() {
      self.addModifier('opened')
      targetPanel.attr('aria-expanded', 'true')
      $('.territoire-main-panel__' + targetPanel.attr('aria-controls')).addClass('territoire-main-panel--opened')
    }, self.close_panels(true))
  }

  self.link_clicked = function(e) {
    e.preventDefault()
    let clicked_link = $(this),
    clicked_id = parseInt(clicked_link.parent().data('id'), 10),
    timeout = 1
    self.map.zoom_to(2, clicked_id)
    if (self.current_location == undefined || self.current_location.id() != clicked_id) {
      $('.--current').removeClass('--current')
      if (self.content_panel.hasModifier('opened')) {
        self.remove_content()
        timeout = 300
      } else {
        self.content_panel.addModifier('opened')
      }
      clicked_link.addClass('--current')
      setTimeout(function() {
        self.append_content(clicked_id)
      }, timeout)
    }
  }

  self.remove_content = function() {
    if (self.current_location != undefined) {
      $('.location-title--current').removeClass('location-title--current')
      $('.--current').removeClass('--current')
      self.current_location.disappear(function() {
        self.current_location.remove()
        self.current_location = undefined
        history.replaceState({}, document.title, window.location.href.split('#')[0]);
      })
    }
  }

  self.append_content = function(id) {
    self.current_location = $('.location[data-id="' + id + '"]').clone().Territoire_Location(self)
    self.content_panel.prepend(self.current_location)
    self.current_location.appear()
    window.location.hash = self.current_location.data('hash')
  }

  return function() {
    self.controls.btnMunicipalites.on('click', self.open_panel)
    self.controls.btnInitiatives.on('click', self.open_panel)
    self.controls.btnCloseMunicipalites.on('click', self.close_panels)
    self.controls.btnCloseInitiatives.on('click', self.close_panels)
    self.controls.btnCloseContent.on('click', self.close_content)
    self.find('.categories__list').Territoire_CategoriesList()
    self.find('.municipalites, .categories').each(function() {
      new Scrollbar($(this), {
        mobile: true,
        preventWheelPropagation: true,
        force: true,
      })
    })
    self.links.on('click', self.link_clicked)
    self.map = self.find('.territoire-map').Territoire_Map(self)
    if (window.location.hash) {
      let hash = window.location.hash.replace('#', '')
      if (hash) {
        let title = $('.location-title[data-hash="' + hash + '"]')
        if (title.length) {
          self.map.getMarker(title.data('id')).clicked()
        }
      }
    }
    self.data('block-territoire', self)
    return self
  }()
}
